import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { PermissionsAPI } from "components/Apis/permessions";

export const fetchPermissions = createAsyncThunk(
    "permissions/fetchPermissions",
    async ({ page, pageSize, search } = {}) => {
        const response = await PermissionsAPI.getAll(page, pageSize, search);
        return response.data;
    }
);

const permissionsSlice = createSlice({
    name: "permissions",
    initialState: {
        list: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchPermissions.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchPermissions.fulfilled, (state, action) => {
                state.loading = false;
                state.list = action.payload;
            })
            .addCase(fetchPermissions.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export default permissionsSlice.reducer;
